import { render } from "./Changelog.vue?vue&type=template&id=cdf28376&ts=true"
import script from "./Changelog.vue?vue&type=script&lang=ts"
export * from "./Changelog.vue?vue&type=script&lang=ts"

import exportComponent from "/home/webchat/thelounge-lfnet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__